import DeleteForever from "@material-ui/icons/DeleteForever";
import TextField from "@material-ui/core/TextField";
import { FieldArray, useFormikContext } from "formik";
import get from "lodash/get";
import React from "react";

import { FormHelperText } from "@material-ui/core";

import Button from "../../../../../forms/custom/Button";
import DropdownInput from "../../../../../forms/custom/DropdownInput.react";

const ALLOCATION_TYPE_OPTIONS = [
  { label: "Project", value: "project" },
  { label: "GL String", value: "gl_string" },
];

const EMPTY_ALLOCATION = { code: "", type: "gl_string" };

function AllocationRow({ idx, arrayHelpers, fieldArrayName }) {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleBlur,
  } = useFormikContext();

  const allocation = get(values, `${fieldArrayName}.${idx}`) || {};
  const rowErrors = get(errors, `${fieldArrayName}.${idx}`);
  const rowTouched = get(touched, `${fieldArrayName}.${idx}`);
  const allAllocations = get(values, fieldArrayName) || [];
  const canDelete = allAllocations.length > 1;

  const isGlString = allocation.type === "gl_string";
  const isDuplicate =
    allocation.code &&
    allAllocations.some((a, i) => i !== idx && a.code === allocation.code);

  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 12, marginBottom: 4 }}>
      <div style={{ flex: "0 0 160px" }}>
        <DropdownInput
          id={`${fieldArrayName}.${idx}.type`}
          label="Type"
          options={ALLOCATION_TYPE_OPTIONS}
          value={allocation.type}
          error={Boolean(get(rowTouched, "type") && get(rowErrors, "type"))}
          helperText={
            get(rowTouched, "type") && get(rowErrors, "type")
              ? get(rowErrors, "type")
              : " "
          }
          onChange={(e) =>
            setFieldValue(`${fieldArrayName}.${idx}.type`, e.target.value)
          }
          onBlur={handleBlur}
          noShrink
        />
      </div>
      <div style={{ flex: 1 }}>
        <TextField
          id={`${fieldArrayName}.${idx}.code`}
          label={isGlString ? "GL String" : "Project Code"}
          value={allocation.code || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(
            (get(rowTouched, "code") && get(rowErrors, "code")) || isDuplicate
          )}
          helperText={
            isDuplicate
              ? "Duplicate allocation code"
              : (get(rowTouched, "code") && get(rowErrors, "code")) ||
                (isGlString ? "e.g. 004.0000.0000.150000.A000.000.0000" : " ")
          }
          fullWidth
          InputLabelProps={isGlString ? { shrink: true } : undefined}
        />
      </div>
      <div style={{ display: "flex", alignItems: "center", paddingTop: 20, flexShrink: 0 }}>
        {canDelete && (
          <DeleteForever
            onClick={() => arrayHelpers.remove(idx)}
            style={{
              color: "#FF6D6D",
              cursor: "pointer",
              fontSize: "24px",
              height: "24px",
              width: "24px",
            }}
          />
        )}
      </div>
    </div>
  );
}

export default function AllocationsField() {
  const { values, errors, touched, submitCount } = useFormikContext();
  const fieldArrayName = "allocations";
  const allocations = get(values, fieldArrayName) || [];

  const topLevelError =
    typeof get(errors, fieldArrayName) === "string" &&
    (submitCount > 0 || get(touched, fieldArrayName))
      ? get(errors, fieldArrayName)
      : null;

  return (
    <div>
      <div
        style={{
          fontSize: "12px",
          fontWeight: 600,
          letterSpacing: "1px",
          color: "#90A4AE",
          textTransform: "uppercase",
          marginBottom: 8,
        }}
      >
        Allocations
      </div>
      <FieldArray
        name={fieldArrayName}
        render={(arrayHelpers) => (
          <>
            {allocations.map((_alloc, idx) => (
              <AllocationRow
                key={idx}
                idx={idx}
                arrayHelpers={arrayHelpers}
                fieldArrayName={fieldArrayName}
              />
            ))}
            <Button
              style={{ border: "none", padding: 0, marginBottom: 12 }}
              onClick={() => arrayHelpers.push({ ...EMPTY_ALLOCATION })}
            >
              + Add Allocation
            </Button>
          </>
        )}
      />
      {topLevelError && (
        <FormHelperText
          style={{ color: "#f44336", fontSize: "0.75rem", marginTop: -4 }}
        >
          {topLevelError}
        </FormHelperText>
      )}
    </div>
  );
}
